module.exports = __webpack_public_path__ + "static/media/dashboard.4b1fd71f.png";